import { Map as ImmutableMap } from 'immutable';

export const fixNullCronExpression = (
  defaultExpressionValue,
  valueIsImmutable = false,
) => {
  if (valueIsImmutable) {
    return (cron) =>
      cron.expression === null
        ? new ImmutableMap({ ...cron, expression: defaultExpressionValue })
        : new ImmutableMap(cron);
  }
  return (cron) =>
    cron.expression === null
      ? { ...cron, expression: defaultExpressionValue }
      : cron;
};
